var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-container",
    [
      _c(
        "div",
        { staticClass: "sticky-top", class: { small: _vm.$wf.isSmDown } },
        [
          _vm._v(" " + _vm._s(_vm.$ct("common.browse.Ticket")) + " "),
          _vm.$wf.isSmDown
            ? _c(
                "span",
                { staticClass: "mr" },
                [
                  _c(
                    "w-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.login()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "sign-in-alt" } })],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _c(
        "w-row",
        { style: { height: "100%" }, attrs: { grow: "" } },
        [
          !_vm.$wf.isSmDown
            ? _c(
                "w-col",
                { attrs: { sm: "12", md: "3", lg: "3" } },
                [
                  _c(
                    "w-card",
                    [
                      _c("div", { staticClass: "action-box" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: `Login`,
                                expression: "`Login`",
                              },
                            ],
                            staticClass: "action-item",
                            on: {
                              click: function ($event) {
                                return _vm.login()
                              },
                            },
                          },
                          [
                            _c("w-fa", { attrs: { icon: "sign-in-alt" } }, [
                              _vm._v(
                                " " + _vm._s(_vm.$ct("common.login")) + " "
                              ),
                            ]),
                          ],
                          1
                        ),
                      ]),
                      _c("app-created-by-winfakt"),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "w-col",
            { attrs: { sm: "12", md: "9", lg: "9" } },
            [
              _c(
                "w-card",
                [_c("app-chat-messages", { attrs: { value: _vm.messages } })],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }